<template>
    <div>
        <label class="tilte-input">{{title}}</label>
        <div class="d-flex justify-content-between">
            <select v-model="day"  class="form-control form-padding-common mr-3">
                <option value="" disabled selected>
                    {{$t('providers.cop.placeholder_component_select_date.day')}}
                </option>
                <option v-for="day in days" :key="day">
                    {{ addZero(day) }}
                </option>
            </select>
            <select v-model="month" @change="changeMonth()" class="form-control form-padding-common mr-3">
                <option value="" disabled selected>
                    {{$t('providers.cop.placeholder_component_select_date.month')}}
                </option>                      
                <option  v-for="month in months" :key="month">
                    {{ addZero(month) }}
                </option>
            </select>
            <select v-model="year" @change="changeYear()"  class="form-control form-padding-common">
                <option value="" disabled selected>
                    {{$t('providers.cop.placeholder_component_select_date.year')}}
                </option>                         
                <option  v-for="year of years" :key="year">
                    {{year}}
                </option>
            </select>
        </div>
    </div>
</template>

<style lang="scss" scoped>

.form-padding-common{
    padding: 0.6rem 0.2rem; 
}

.tilte-input{
  font-size: 0.9rem;
  color: black;
}

@media screen and (min-width: 576px){
    .form-padding-common{
        padding: 0.6rem 1rem; 
    }
}
</style>
<script>
export default {
  props:{
    title: String,
    value: String,
    reset: Boolean
  },
  data(){
    return { 
        days: 31,
        months: 12,
        month: '',
        day:'',
        year: '',
        currentYear: 1990,
        currentMonth: 1,
        isCurrentYear: false,
        isCurrentMonth: false,
    }
  },
  watch: {
    reset(){
        this.day = "";
        this.month = "";
        this.year = "";
    },
    day(value){
        this.day = value;
        if(this.day == ''){
            console.log(this.day);
            this.$emit("input", "");
        }else{
            if(this.month == '' || this.year == ''){
                this.$emit("input", this.day);
                return;
            }
            console.log(this.day);
            var datetime = this.year+"-"+ this.month +"-"+ this.day;
            // this.$emit("input", new Date(datetime).toISOString());
            this.$emit("input", datetime);
        }
    },
    month(value){
         this.month = value;
        if(this.month == ''){
            this.$emit("input", "");
        }else{
            var datetime = this.year+"-"+ this.month +"-"+ this.day;
            // this.$emit("input", new Date(datetime).toUTCString());
             this.$emit("input", datetime);
        }
    },
    year(value){
        this.year = value;
        if(this.year == ''){
            this.$emit("input", "");
        }else{
            var datetime = this.year+"-"+ this.month +"-"+ this.day;
            // this.$emit("input", new Date(datetime).toUTCString());
             this.$emit("input", datetime);
        }
    }, 
    value(){
        if(this.day == '' || this.month == '' || this.year ==''){
              this.$emit("input", "");
        }else{
            // toISOString
            var datetime = this.year+"-"+ this.month +"-"+ this.day;
            // this.$emit("input", new Date(datetime).toUTCString());
            this.$emit("input", datetime);
        }
    }
  },
  computed: {
    years(){
        var year = new Date().getFullYear() + 1;
        return Array.from({ length: year - 1950}, (value, index) => 1950 + index ).sort(function(a,b) {return b-a} );
    },

  },
  methods:{
    addZero(value){
        if(value < 10){
            return "0"+ value;
        }
        return value;
    },
    isCheckLeapYear(year){
        if( (year % 4 == 0 && year % 100 != 0) || year % 400 == 0){
            return true;
        }
        return false;
    },
    changeYear(){
        var year = new Date().getFullYear();
        this.currentYear = event.target.value;
        var month = new Date().getMonth();
        this.isCurrentYear = (year == this.currentYear);
        this.months = this.isCurrentYear ? month : 12;
        this.changeDayByMonth(this.currentMonth);
        this.$emit("input", this.currentYear);
    },
    changeDayByMonth(month){
        var now = new Date();
        var date = now.getDate();
        var currentMonth = now.getMonth();

        if(this.isCurrentYear && (month == currentMonth)){
            this.days = date;
            return ;
        }
        switch(Number(month)){
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
               this.days = 31;
               break;
            case 4:
            case 6:
            case 9:
            case 11:
                this.days = 30;
               break;
            case 2:
                this.days = this.isCheckLeapYear(Number(this.currentYear)) ? 29 : 28;
                break;
        }
    },
    changeMonth(){
        this.currentMonth = event.target.value;
        this.changeDayByMonth(this.currentMonth);
    }
  }
}
</script>